<template>
  <div></div>
</template>
<script setup lang="ts">
import message from "ant-design-vue/es/message"
import { getToken, setToken } from "@/utils"
import { MessageToCode } from "./interface"
import { getAllToken } from "@/utils/index"
import { refreshToken } from "@/services"
import mittBus from "@/utils/mitt"
import router from "@/router"
import { useUserInfo } from "@/store"
const userStore = useUserInfo()

// WebSocket.CONNECTING = 0  // 正在连接，还没建立成功
// WebSocket.OPEN       = 1  // 连接已建立，可以收发数据
// WebSocket.CLOSING    = 2  // 连接正在关闭（调用了 close() 或远端正在关闭）
// WebSocket.CLOSED     = 3  // 连接已经关闭或无法打开

const emit = defineEmits(["rollback", "update:visible", "syncMessage"])

const props = defineProps<{
  visible?: boolean
  uri?: string
  did?: number
  page: number
}>()

const { t } = useI18n()

const state = reactive({
  // webSocket: ref(), // webSocket实例
  webSocket: null as WebSocket | null,
  lockReconnect: false, // 重连锁，避免多次重连
  maxReconnect: 4, // 最大重连次数， -1 标识无限重连
  reconnectTime: 0, // 重连尝试次数
  heartbeat: {
    interval: 30 * 1000, // 心跳间隔时间
    timeout: 10 * 1000, // 响应超时时间
    pingTimeoutObj: ref(), // 延时发送心跳的定时器
    pongTimeoutObj: ref(), // 接收心跳响应的定时器
    pingMessage: JSON.stringify({ type: "ping" }) // 心跳请求信息
  }
})

let inactivityTimer: any = null
let heartbeatTimer: any = null

const websocketVisible = computed({
  get: () => props.visible,
  set: (val) => {
    emit("update:visible", val)
  }
})

watch(
  () => props.page,
  (newVal) => {
    console.log("当前页面", newVal, state.webSocket)
    if (state.webSocket?.readyState === WebSocket.OPEN) {
      state.webSocket.send(JSON.stringify({ act: "switch_page", page: newVal - 1 }))
    }
  },
  {
    immediate: false
  }
)

/**
 * 关闭链接
 */
const close = () => {
  if (state.webSocket) state.webSocket.close()
  websocketVisible.value = false
}

const initWebSocket = () => {
  // ws地址 - 优先使用传入的uri参数
  let host = props.uri ? props.uri : import.meta.env.VITE_WS_URL
  // let baseURL = props.uri ? props.uri : import.meta.env.VITE_WS_URL
  //   var protocol = window.location.protocol 获取页面使用的协议
  let prefix = "wss"

  //   if (protocol === "https:") {
  //     prefix = "wss"
  //   } else {
  //     prefix = "ws"
  //   }

  const token = getToken()

  console.log("token---", token)
  let wsUri = `${prefix}://${host}/${props.did}?token=${token}&page=${props.page - 1}`
  // console.log("websocket请求连接", wsUri)

  // 建立连接
  state.webSocket = new WebSocket(wsUri)
  // 连接成功
  state.webSocket.onopen = onOpen
  // 连接错误
  state.webSocket.onerror = onError
  // 接收信息
  state.webSocket.onmessage = onMessage
  // 连接关闭
  state.webSocket.onclose = onClose
}

const reconnect = () => {
  if (state.lockReconnect) {
    return
  }
  if (state.maxReconnect !== -1 && state.reconnectTime > state.maxReconnect) {
    message.error(t("monitor.collectFail"))
    close()
    return
  }
  state.lockReconnect = true
  setTimeout(() => {
    state.reconnectTime++
    // 建立新连接
    initWebSocket()
    state.lockReconnect = false
  }, 2000)
}

// 发送心跳消息
function startHeartbeat() {
  const webSocket = state.webSocket
  stopHeartbeat()
  heartbeatTimer = setInterval(() => {
    if (webSocket && webSocket.readyState === 1) {
      webSocket.send(JSON.stringify({ type: "ping" }))
      console.log("➡️ 发送心跳 ping")
    }
  }, 1000 * 10) // 每10秒发送一次心跳
}

// 停止心跳
function stopHeartbeat() {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer)
    heartbeatTimer = null
  }
}
/**
 * 清除无消息定时器
 */
const clearInactivityTimer = () => {
  if (inactivityTimer) {
    clearTimeout(inactivityTimer)
    inactivityTimer = null
  }
}
/**
 * 重置无消息定时器
 * 如果 5分钟没收到任何消息，就提示采集中断并关闭连接
 */
const resetInactivityTimer = () => {
  console.log("监听是否有消息")
  clearInactivityTimer()
  inactivityTimer = setTimeout(() => {
    console.log("5分钟没收到消息采集中断")
    close()
    message.error(t("monitor.gathertip"))
  }, 5 * 60 * 1000) // 5 分钟
}
// 5 * 60 * 1000

/**
 * 连接成功事件
 */
const onOpen = () => {
  console.log("连接成功")
  state.reconnectTime = 0
  resetInactivityTimer() // 建立连接后启动无消息计时
  startHeartbeat()
}
/**
 * 连接失败事件
 * @param e
 */
const onError = async (e: Event) => {
  console.log("websocket连接错误错误")
  close()
  message.error(t("E_INVALID_OR_EXPIRED_TOKEN"))
  mittBus.emit("logout")
  localStorage.removeItem("TOKEN")
  localStorage.removeItem("HOST")
  userStore.$reset()
  router.replace("/login")
  // const token = getAllToken()
  // if (token.rToken && token.token) {
  //   const { data: newToken, msg: tokenMsg } = await refreshToken(token.rToken, token.token, true)
  //   if (!tokenMsg) {
  //     setToken(newToken, token.rToken)
  //     reconnect()
  //   } else {
  //     console.log("重新刷新的token无效")
  //   }
  // }
}

/**
 * 连接关闭事件
 * @param e
 */
const onClose = (event: CloseEvent) => {
  console.log("关闭关闭", event)
  websocketVisible.value = false
  // close()
}
/**
 * 接收服务器推送的信息
 * @param msgEvent
 */
const onMessage = (msgEvent: any) => {
  const { data, act } = msgEvent
  emit("syncMessage", JSON.parse(data))
  resetInactivityTimer() // 每次收到消息就重置计时
}

onMounted(() => {
  initWebSocket()
})

onUnmounted(() => {
  console.log("销毁销毁", state.webSocket)
  if (state.webSocket?.readyState !== 3) {
    state.webSocket?.close()
  }
  clearInactivityTimer()
  stopHeartbeat()
})

defineExpose({
  state
})
</script>
<style>
a {
  text-decoration: underline;
  color: var(--el-color-primary);
}
</style>
